// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const ROUTESUMMARY_HYDRATE = 'ROUTESUMMARY_HYDRATE';
export const hydrateRouteSummary = makeActionCreator(ROUTESUMMARY_HYDRATE, 'data');
